/** @license Guesty v2.0.15-alpha.15
 *
 * This source code is licensed under the ISC license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { FormattedNumber // TODO: Wrap in our own component folder
// FormattedDate, // TODO: After we will deprecated moment, move to the react-intl based components for date and time formatting
// FormattedTime, // TODO: Wrap in our own component folder
, FormattedRelativeTime } from 'react-intl';
import intl from "./intl/intl";
import useIntl from "./useIntl/useIntl";
import LocalizationProvider from "./LocalizationProvider";
import FormattedMessage from "./FormattedMessage";
import FormattedTime from "./FormattedTime";
import FormattedDate from "./FormattedDate";
import FormattedCurrency from "./FormattedCurrency";
import Moment from "./Moment";
export { intl, useIntl, LocalizationProvider, FormattedMessage, FormattedNumber, FormattedCurrency, FormattedDate, FormattedTime, FormattedRelativeTime, Moment };